





























import { Component, Vue, Prop } from 'vue-property-decorator'
import TopMenu from './Components/TopMenu.vue'
import TableMenu from './Components/TableMenu.vue'
import Pagination from '@/app/ui/components/Pagination/index'
import { NotificationModule } from '@/app/store/modules/notifications'

@Component({
  name: 'Notifications',
  components: {
    'top-menu': TopMenu,
    'table-menu': TableMenu,
    pagination: Pagination,
  },
})
export default class extends Vue {
  private selected = []

  public created() {
    NotificationModule.paginationParam.search = ''
    this.getNotification()
  }

  public get page() {
    return NotificationModule.Pages
  }
  public get limit() {
    return NotificationModule.Limit
  }

  public get notificationData() {
    return NotificationModule.notificationData
  }

  public get isLoading() {
    return NotificationModule.isLoading
  }

  public get fields() {
    return NotificationModule.fields
  }

  public getNotification() {
    NotificationModule.getNotificationData()
  }

  // Property Top Menu
  private funcSearch(item) {
    NotificationModule.paginationParam.search = item
    this.getNotification()
  }

  private onPageNumChanged(limit: any) {
    NotificationModule.paginationParam.paging.limit = limit
    this.getNotification()
  }

  private funcFirstPage() {
    NotificationModule.paginationParam.paging.page = 1
    this.getNotification()
  }

  private funcPrevPage() {
    NotificationModule.paginationParam.paging.page =
      NotificationModule.paginationParam.paging.page - 1
    this.getNotification()
  }
  private funcNextPage() {
    NotificationModule.paginationParam.paging.page =
      NotificationModule.paginationParam.paging.page + 1
    this.getNotification()
  }

  private funcLastPage() {
    NotificationModule.paginationParam.paging.page =
      (this.notificationData.pagination &&
        this.notificationData.pagination.pageCount) ||
      0
    this.getNotification()
  }

  private onRowSelected(items) {
    this.selected = items
  }
  public clearTableStatus: boolean = false
  public clearRowSelected() {
    this.selected = []
    if (this.clearTableStatus === false) {
      this.clearTableStatus = true
    } else {
      this.clearTableStatus = false
    }
  }
}
